import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import OrderDetailsHeader from './components/OrderDetailsHeader';
import OrderDetailsBody from './components/OrderDetailsBody';
import SuperAdminOfferDetails from './components/SuperAdminOfferDetails';
import NotSuperAdminOfferDetails from './components/NotSuperAdminOfferDetails';

export default function OrderDetials({ orderId, numberOfForms, language, orderDescription, subServices, orderStatus, offerStatus, serviceName, offerPrice, offerNote, offerFile, customerEmail, customerName, customerPhone, adminRole }) {
    const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(null);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            price: offerPrice,
            notes: offerNote,
            file: offerFile,
            // status: null, // This will be set based on the admin role 
        }
    });

    return (
        <div id={`order-details-${orderId}`}
            className="modal fade"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="orderDetailsLabel"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="orderDetailsLabel">تفاصيل العرض {orderId}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {(orderStatus[2] === "معتمد" || orderStatus[2] === "تم الدفع") ?
                            <div className="alert alert-success text-center" role="alert">
                                {orderStatus[2]}</div> : offerPrice > 1 ?
                                <div className="alert alert-warning text-center" role="alert">
                                    في انتظار الرد أو للمراجعة</div> :
                                <div className="alert alert-info text-center" role="alert">
                                    لا يوجد عرض مقدم</div>
                        }
                        <OrderDetailsHeader
                            customerEmail={customerEmail}
                            customerName={customerName}
                            customerPhone={customerPhone}
                        />
                        <OrderDetailsBody
                            numberOfForms={numberOfForms}
                            language={language}
                            subServices={subServices}
                            orderStatus={orderStatus}
                            orderDescription={orderDescription}
                            serviceName={serviceName}
                        />
                        {adminRole === "superAdmin" &&
                            <SuperAdminOfferDetails
                                offerStatus={offerStatus}
                                offerPrice={offerPrice}
                                offerNote={offerNote}
                                offerFile={offerFile}
                                toast={toast}
                                orderId={orderId}
                                loading={loading}
                                setLoading={setLoading}
                                handleSubmit={handleSubmit}
                                ToastContainer={ToastContainer}
                                setValue={setValue}
                            />
                        }
                        {adminRole !== "superAdmin" &&
                            <NotSuperAdminOfferDetails
                                loading={loading}
                                setLoading={setLoading}
                                setValue={setValue}
                                handleSubmit={handleSubmit}
                                ToastContainer={ToastContainer}
                                errors={errors}
                                register={register}
                                orderId={orderId}
                                offerStatus={offerStatus}
                                orderStatus={orderStatus}
                            />

                        }
                    </div>
                </div>
            </div>
        </div>
    );
}